import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import PropTypes from 'prop-types';

const RSVPFrom = ({ maxGuests = 0, host, handle }) => {
    const [forms, setForms] = useState({
        assistants: '',
        message: '',
        can_assist: true, // true for "Sí, asistiré", false for "No podré asistir"
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage',
        validators: {
            required: {
                rule: (val) => val !== undefined && val !== null && val !== '',
                message: 'Este campo es obligatorio'
            }
        }
    }));
    const changeHandler = e => {
        if (e.target.name === 'radio-group') {
            setForms({ ...forms, can_assist: e.target.id === 'attend' });
        } else {
            setForms({ ...forms, [e.target.name]: e.target.value });
        }
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        
        // Only validate assistants if can_assist is true
        const isValid = forms.can_assist 
            ? validator.allValid() && forms.assistants !== ''
            : true;

        if (isValid) {
            validator.hideMessages();
            setIsSubmitting(true);
            setSubmitStatus(null);

            try {
                const requestOptions = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        can_assist: forms.can_assist,
                        count: forms.can_assist ? parseInt(forms.assistants) : 0,
                        confirmation_message: forms.message
                    })
                };

                const response = await fetch(`${host}/confirm-guests/${handle}`, requestOptions);
                const result = await response.json();

                if (response.ok) {
                    setSubmitStatus({ 
                        type: 'success', 
                        message: forms.can_assist 
                            ? '¡Muchas gracias por confirmar, nos vemos en la boda! 🎉 💃🕺💃' 
                            : 'Sentimos que no puedas asistir, pero seguimos en contacto para celebrar en un futuro! 💖'
                    });
                    setForms({
                        assistants: '',
                        message: '',
                        can_assist: true,
                    });
                } else {
                    setSubmitStatus({ type: 'error', message: result.error || 'Hubo un error al enviar tu confirmación' });
                }
            } catch (error) {
                setSubmitStatus({ type: 'error', message: 'Hubo un error al enviar tu confirmación' });
                console.error('Error submitting form:', error);
            } finally {
                setIsSubmitting(false);
            }
        } else {
            validator.showMessages();
        }
    };

    // Generate options array based on maxGuests
    const guestOptions = maxGuests === 0 
        ? [{ value: '', label: 'No hay lugares disponibles' }]
        : [
            { value: '', label: 'Número de asistentes' },
            { value: '1', label: 'Sólo yo 😏' },
            ...Array.from({ length: maxGuests - 1 }, (_, i) => ({
                value: String(i + 2),
                label: String(i + 2).padStart(2, '0') + ' personas'
            }))
        ];

    return (
        <form onSubmit={(e) => submitHandler(e)} className="contact-validation-active" >
            <div className="row">
                <div className="col col-lg-12 col-12">
                    <div className="radio-buttons">
                        <p>
                            <input 
                                type="radio" 
                                id="attend" 
                                name="radio-group" 
                                defaultChecked
                                onChange={(e) => changeHandler(e)}
                            />
                            <label htmlFor="attend">Sí, asistiré</label>
                        </p>
                        <p>
                            <input 
                                type="radio" 
                                id="not" 
                                name="radio-group"
                                onChange={(e) => changeHandler(e)}
                            />
                            <label htmlFor="not">Disculpen, no podré asistir</label>
                        </p>
                    </div>
                </div>
                {forms.can_assist && (
                    <div className="col col-lg-12 col-12">
                        <div className="form-field">
                            <select
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                                value={forms.assistants}
                                type="text"
                                className="form-control"
                                name="assistants"
                                disabled={maxGuests === 0}>
                                {guestOptions.map((option, index) => (
                                    <option key={index} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                            {forms.can_assist && validator.message('assistants', forms.assistants, 'required')}
                        </div>
                    </div>
                )}
                <div className="col col-lg-12 col-12">
                    <div className="form-field">
                        <input
                            value={forms.message}
                            type="text"
                            name="message"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            className="form-control"
                            placeholder="¿Algún mensaje para nosotros?" />
                    </div>
                </div>
            </div>
            <div className="submit-area">
                {submitStatus && (
                    <div className={`alert ${submitStatus.type === 'success' ? 'alert-success' : 'alert-danger'}`}>
                        {submitStatus.message}
                    </div>
                )}
                <button 
                    type="submit" 
                    className="theme-btn"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Enviando...' : 'Enviar'}
                </button>
            </div>
        </form>
    )
}

RSVPFrom.propTypes = {
    maxGuests: PropTypes.number.isRequired,
    host: PropTypes.string.isRequired,
    handle: PropTypes.string.isRequired
};

export default RSVPFrom;